import './input.css';
import React, { useEffect, useRef, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';

const MDrop: React.FC<InputProp> = (props) => {
	const { type, setState, state, isArray, arrayName, indexVal, returnKey, fieldName, className = '', options = [], optionDisplay, optionKey, required = false, disabled = false, onChange, optionsAll, typable, didntShowKey, valueShowKey, dropdownWidthStyle, keyId } = props;

	const [selected, setSelected] = useState<string[]>([]);
	const [isDropdownVisible, setIsDropdownVisible] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const dropdownRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isArray) {
			if (indexVal !== undefined && returnKey && arrayName && state[arrayName]) {
				const value = state[arrayName][indexVal]?.[returnKey];
				setSelected(Array.isArray(value) ? value : [value]); // Ensure it's always an array
			}
		} else {
			if (returnKey && state?.[returnKey]) {
				setSelected(Array.isArray(state[returnKey]) ? state[returnKey] : []);
			} else {
				setSelected([]);
			}
		}
	}, [state, returnKey, isArray, indexVal, arrayName]);

	const handleSelect = (singleValue: any) => {
		console.log('singleValue', singleValue);

		const key = singleValue ? (optionKey ? singleValue[optionKey] : singleValue) : '';
		const value = selected.includes(key) ? selected.filter((item) => item !== key) : [...selected, key];

		setSelected(value);

		try {
			if (isArray) {
				if (!arrayName || indexVal === undefined || !returnKey || !setState) {
					console.error('Missing required parameters for array handling');
					return;
				}

				const updatedState = { ...state };

				if (!updatedState[arrayName]) {
					updatedState[arrayName] = [];
				}

				while (updatedState[arrayName].length <= indexVal) {
					updatedState[arrayName].push({});
				}

				if (typeof updatedState[arrayName][indexVal] !== 'object' || updatedState[arrayName][indexVal] === null) {
					updatedState[arrayName][indexVal] = {};
				}

				updatedState[arrayName][indexVal][returnKey] = value;

				setState(updatedState);
				setIsDropdownVisible(false);
			} else {
				if (!setState) {
					console.error('setState function is required');
					return;
				}

				if (returnKey) {
					setState({ ...state, [returnKey]: value });
				} else {
					setState(value);
				}
			}
		} catch (error) {
			console.error('An error occurred in handleSelect:', error);
		}
	};

	const handleClickOutside = (e: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
			setIsDropdownVisible(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const filteredOptions = options.filter((option: any) => {
		const displayValue = optionDisplay ? option[optionDisplay] : option || '';
		if (!searchTerm) return true;
		return displayValue?.toLowerCase()?.includes(searchTerm?.toLowerCase() || "");
	});

	return (
		<label key={keyId} className={`block ${className}`}>
			<div className='relative min-h-14' ref={dropdownRef}>
				<label className='block text-sm font-medium text-gray-700 mb-1 dark:text-slate-300'>{fieldName}</label>

				<div onClick={() => setIsDropdownVisible(!isDropdownVisible)} className='w-full min-h-[42px] px-4 py-2 dark:text-slate-300 border   bg-slate-100 dark:bg-neutral-800 border-gray-500 rounded-lg shadow-sm text-sm text-gray-900 cursor-pointer flex items-center justify-between hover:border-indigo-400 focus:ring-2 focus:ring-indigo-500 focus:outline-none'>
					<span className='truncate'>
						{Array.isArray(selected) && selected.length > 0
							? selected
									.map((key) => {
										const option = options.find((opt) => (optionKey ? opt[optionKey] === key : opt === key));
										if (!option) return '';
										return optionDisplay ? option[optionDisplay] || '' : key;
									})
									.join(', ')
							: 'Select...'}
					</span>

					<svg className={`w-4 h-4 ml-2 transform transition-transform duration-200 ${isDropdownVisible ? 'rotate-180' : ''}`} fill='none' stroke='currentColor' strokeWidth='2' viewBox='0 0 24 24'>
						<path strokeLinecap='round' strokeLinejoin='round' d='M19 9l-7 7-7-7' />
					</svg>
				</div>

				{isDropdownVisible && (
					<div className='absolute z-10 w-full mt-1 bg-slate-100 dark:bg-neutral-800 border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto'>
						<input type='text' placeholder='Search...' autoComplete="off"  value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-full px-1 py-1 border-b border-gray-300  bg-slate-100 dark:bg-neutral-800 focus:outline-none sm:text-sm' />
						<ul className='focus:outline-none list-none sm:text-sm'>
							{filteredOptions
								.sort((a: any, b: any) => {
									const keyA = optionKey ? a[optionKey] : a;
									const keyB = optionKey ? b[optionKey] : b;
									const aSelected = selected.includes(keyA);
									const bSelected = selected.includes(keyB);
									return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
								})
								.map((option: any, index: any) => {
									const key = optionKey ? option[optionKey] : option;
									const displayValue = optionDisplay ? option[optionDisplay] : option;

									return (
										<li key={index} onClick={() => handleSelect(option)} className='flex items-center px-2 py-2 m-1 cursor-pointer '>
											<div className='flex h-5 content-center w-full'>
												<input type='checkbox' checked={selected.includes(key)} readOnly className='mr-3 h-5 w-5 '  />
												<div className='text-sm font-medium  text-gray-900 dark:text-slate-500'>{displayValue}</div>
											</div>
										</li>
									);
								})}
						</ul>
					</div>
				)}
			</div>
		</label>
	);
};

export default MDrop;
